import axios from 'axios';

axios.defaults.baseURL = 'https://app.incentivemeet.com';
//for testing, change CORS on backend, set with Credentials and secure and same-site none 
//axios.defaults.baseURL = 'http://localhost:8800'; 
axios.defaults.withCredentials = true;

export default axios;
